import Cookies from "universal-cookie";
import createCookieOptions from "./createCookieOptions";

export default function setCookie(name: string, value: string | number): void {
  const options = createCookieOptions(process.env.REACT_APP_COOKIE_DOMAIN);
  new Cookies().set(name, value, options);
}
